/*
 * Feed ActionList
 * Action popups for each feed post/reply
 * Eg: Follow, Share, Report, etc
 *
 * @author: Elton Jain
 */
/*global require, define*/

define('modules/Feed/FeedAction',[
    'jquery',
    'UI',
    'JSTemplate',
    'History',
    'modules/common/Constants',
    'Helper',
    'modules/common/Sharer',
    'Config'
], function($, UI, template, History, Constants, Helper, Sharer, Config) {
    'use strict';

    var eleActionMenu = '#popup-action-menu',
        ActionList = {},
        FeedAction,
        langs = Config.get('lang');

    // Action List
    ActionList = {
        // Questions
        post_follow: {
            name: langs.follow_post,
            icon: 'ion-android-bookmark',
            api: '/ajax/question/follow',
            callback: function(apiData, extraOptions) {
                justCallApi(this.api, apiData, function() {

                    if(window._gtap.data.f && window._gtap.data.f[apiData.questionId]) {
                        window._gtap.data.f[apiData.questionId].actions.follow = false;
                        window._gtap.data.f[apiData.questionId].actions.unfollow = true;
                    }

                    if (extraOptions.$actionBtn && extraOptions.$actionBtn.data('actions')) {
                        var actions = extraOptions.$actionBtn.data('actions');

                        if (typeof actions === 'string') {
                            actions = $.parseJSON(actions);
                        }

                        delete actions.follow;
                        actions.unfollow = true;
                        extraOptions.$actionBtn.attr('data-actions', '"' + JSON.stringify(actions) + '"');
                    }

                    if(extraOptions.callback) {
                        extraOptions.callback();
                    }
                    
                });
            }
        },
        post_unfollow: {
            name: langs.unfollow_post,
            icon: 'ion-android-notifications-off',
            api: '/ajax/question/unfollow',
            callback: function(apiData, extraOptions) {
                justCallApi(this.api, apiData, function() {

                    if(window._gtap.data.f && window._gtap.data.f[apiData.questionId]) {
                        window._gtap.data.f[apiData.questionId].actions.follow = true;
                        window._gtap.data.f[apiData.questionId].actions.unfollow = false;
                    }

                    if (extraOptions.$actionBtn && extraOptions.$actionBtn.data('actions')) {

                        var actions = extraOptions.$actionBtn.data('actions');

                        if (typeof actions === 'string') {
                            actions = $.parseJSON(actions);
                        }

                        delete actions.unfollow;
                        actions.follow = true;
                        extraOptions.$actionBtn.attr('data-actions', '"' + JSON.stringify(actions) + '"');
                    }

                    if(extraOptions.callback) {
                        extraOptions.callback();
                    }
                });
            }
        },
        post_report: {
            name: langs.report_post,
            icon: 'ion-flag',
            api: '/ajax/report/reason',
            ask: langs.rep_p,
            callback: function(apiData) {
                apiData = apiData || {};
                apiData.entityId = apiData.questionId;
                initContentReportProcess.call(this, apiData, 'question');
            }
        },
        post_report_user: {
            name: langs.report_user,
            icon: 'ion-flag',
            api: '/ajax/report/reason',
            ask: langs.rep_user,
            callback: function(apiData) {
                apiData = apiData || {};
                apiData.entityId = apiData.userId;
                apiData.entityReasonId = apiData.questionId;
                initContentReportProcess.call(this, apiData, 'question_user');
            }
        },
        post_remove: {
            name: langs.popup_delete,
            icon: 'ion-android-remove-circle',
            api: '/ajax/question/remove',
            callback: function(apiData) {
                var a = confirm('Are you sure you want to delete this question?');
                if (a) {
                    $.post(this.api, apiData, function(response) {
                        if (response.status === true) {
                            $('#feed-post-' + apiData.questionId).remove();
                            // If Detail popup, popstate
                            if($('#app-page-answer').length) {
                                History.popState();
                            }
                            // Redirect if question page
                            if (response.redirect_url) {
                                window.location.href = response.redirect_url;
                            }
                        } else {
                            alert(response.message);
                        }
                    });
                }
                // closeActionPopup();
            }
        },

        post_hide: {
            name: langs.hide_this_post,
            icon: 'ion-eye-disabled',
            api: '/ajax/question/follow',
            callback: function(apiData, extraOptions) {
                justCallApi(apiData.url, apiData, function() {
                    var $eleQuestion = $('#feed-post-' + apiData.questionId); 
                    $eleQuestion.hide('slow');            
                });
            }
        },

        post_skip: {
            name: langs.skip_this_poll,
            icon: 'ion-skip-forward',
            api: '/ajax/question/follow',
            callback: function(apiData, extraOptions) {
                justCallApi(apiData.url, apiData, function() {
                    var $eleQuestion = $('#feed-post-' + apiData.questionId); 
                    $eleQuestion.hide('slow');            
                });
            }
        },
        post_edit: {
            name: langs.popup_edit,
            icon: 'ion-edit',
            api: '/ajax/question/edit',
            callback: function(apiData) {
                var base = this,
                    validationRules = {
                        message: {
                            presence: {
                                message: '^' + langs.err_q_blank
                            },
                            length: {
                                minimum: 10,
                                tooShort: '^' + langs.err_q_len
                            }
                        }
                    };
                // If single question page is open
                var $elQPageOverlay = $('#app-page-answer[data-q='+apiData.questionId+']');
                if($elQPageOverlay.length) {
                    var $eleQuestion = $elQPageOverlay.find('.feed-post');
                } else {
                    var $eleQuestion = $('#feed-post-' + apiData.questionId);
                }

                var questionData = window._gtap.data.f[apiData.questionId],
                    $eleQuestionText = $eleQuestion.find('.q-text'),
                    qText = '';

                if($('.form-q-edit[data-id='+apiData.questionId+']').length) {
                    return false;
                }

                if(questionData) {
                    qText = questionData.topic.message;
                } else {
                    qText = $.trim($eleQuestionText.text());
                }

                apiData = $.extend(apiData, {
                    id: apiData.questionId,
                    message: qText,
                    langs: langs
                });
                // $eleQuestionText.attr('contentEditable', true);
                var $elEditForm = $(template('tplQuestionEditForm', apiData));
                enableQAEdit($eleQuestion, $eleQuestionText, qText, $elEditForm, base.api, validationRules, function (newText) {
                    if(questionData) {
                        window._gtap.data.f[apiData.questionId].topic.message = newText;
                    }
                });

                return false;
            }
        },

        // Answers
        answer_report: {
            name: langs.popup_report_answer,
            icon: 'ion-flag',
            api: '/ajax/report/reason',
            ask: 'Why are you reporting this answer?',
            callback: function (apiData) {
                apiData = apiData || {};
                apiData.entityId = apiData.answerId;
                initContentReportProcess.call(this, apiData, 'answer');
            }
        },
        answer_report_user: {
            name: langs.report_user,
            icon: 'ion-flag',
            api: '/ajax/report/reason',
            ask: 'Why are reporting this user?',
            callback: function (apiData) {
                apiData = apiData || {};
                apiData.entityId = apiData.userId;
                apiData.entityReasonId = apiData.answerId;
                initContentReportProcess.call(this, apiData, 'answer_user');
            }
        },
        answer_remove: {
            name: langs.popup_delete,
            icon: 'ion-android-remove-circle',
            api: '/ajax/answer/remove',
            callback: function(apiData) {
                var a = confirm('Are you sure you want to delete this answer?');
                if (a) {
                    $.post(this.api, apiData, function(response) {
                        if (response.status === true) {
                            $('#answer-' + apiData.answerId).remove();
                        } else {
                            alert(response.message);
                        }
                    });
                }
                // closeActionPopup();
            }
        },
        comment_remove: {
            name: langs.popup_delete,
            icon: 'ion-android-remove-circle',
            api: '/ajax/answer/comment/remove',
            callback: function(apiData) {
                var a = confirm('Are you sure you want to delete this comment?');
                if (a) {
                    $.post(this.api, apiData, function(response) {
                        if (response.status === true) {
                            $('#comment-' + apiData.commentId).remove();
                        } else {
                            alert(response.message);
                        }
                    });
                }
                //History.popState();
                //closeActionPopup();
            }
        },
        answer_edit: {
            name: langs.popup_edit,
            icon: 'ion-edit',
            api: '/ajax/answer/edit',
            callback: function(apiData) {
                var base = this,
                    $eleAnswer = $('#answer-' + apiData.answerId),
                    $eleAnswerText = $eleAnswer.find('.cmt-text').first(),
                    answerText = '',
                    validationRules = {
                        message: {
                            presence: {
                                message: '^Answer cannot be blank'
                            },
                            length: {
                                minimum: 2,
                                tooShort: '^Answer must be at least %{count} characters'
                            }
                        }
                    },
                    answerData = window._gtap.data.fa[apiData.answerId],
                    answerId = apiData.answerId;

                if($('.form-cmt-edit[data-id='+answerId+']').length) {
                    return false;
                }
                if(answerData) {
                    answerText = answerData.message;
                } else {
                    answerText = $.trim($eleAnswerText.text());
                }

                apiData = $.extend(apiData, {
                    id: answerId,
                    message: answerText,
                    langs: langs
                });

                // $eleQuestionText.attr('contentEditable', true);
                var $elEditForm = $(template('tplAnswerEditForm', apiData));

                // Code being same for both Q and A edit forms
                enableQAEdit($eleAnswer, $eleAnswerText, answerText, $elEditForm, base.api, validationRules, function (newText) {
                    if(window._gtap.data.fa[answerId]) {
                        window._gtap.data.fa[answerId].message = newText;
                    }
                });

                return false;
            }
        },


        // User
        user_report: {
            name: langs.report_user,
            icon: 'ion-facebook',
            api: '/ajax/report/reason',
            ask: 'Why are you reporting this user?',
            callback: function (apiData) {
                apiData = apiData || {};
                apiData.entityId = apiData.userId;
                initContentReportProcess.call(this, apiData, 'user');
            }
        },

        // Sharing
        share_social: {
            callback: function(platform, url) {
                Sharer.share(platform, url);
            }
        },
        share_twitter: {
            name: 'Share on Facebook',
            icon: 'ion-flag',
            api: '/ajax/user/report',
            callback: function() {}
        },

        // Booth
        booth_remove: {
            name: langs.popup_delete,
            icon: 'ion-android-remove-circle',
            api: '/ajax/booth/remove',
            callback: function(apiData) {
                var a = confirm('Are you sure you want to delete this picture?');
                if (a) {
                    $.post(this.api, apiData, function(response) {
                        if (response.status === true) {
                            $('#booth-id-' + apiData.boothId).hide('slow',function() {
                                $('#booth-id-' + apiData.boothId).remove();
                            });
                        }
                    });
                }
                // closeActionPopup();
            }
        },

        booth_edit: {
            name: langs.popup_edit,
            icon: 'ion-edit',
            api: '/ajax/booth/edit',
            callback: function(apiData) {
                var base = this,
                    $eleBooth = $('#booth-id-' + apiData.boothId),
                    $eleBoothText = $eleBooth.find('.booth-text'),
                    boothText,
                    validationRules = {
                        message: {
                            presence: {
                                message: '^' + langs.err_c_blank
                            }
                        }
                    };

                if($eleBooth.find('.hidden-booth-text').length > 0) {
                    boothText = $.trim($eleBooth.find('.hidden-booth-text').text());
                } else {
                    boothText = $.trim($eleBooth.find('.booth-text').text());
                }

                // if(window._gtap.data.fa[answerId]) {
                //     answerText = (window._gtap.data.fa[answerId].message);
                // }

                apiData = $.extend(apiData, {
                    message: boothText,
                    langs: langs
                });

                // $eleQuestionText.attr('contentEditable', true);
                var $elEditForm = $(template('tplBoothEditForm', apiData));

                // Code being same for both Q and A edit forms
                enableQAEdit($eleBooth, $eleBoothText, boothText, $elEditForm, base.api, validationRules, function (newText) {
                    // if(window._gtap.data.fa[answerId]) {
                    //     window._gtap.data.fa[answerId].message = newText;
                    // }
                });

                return false;
                
            }
        },

        booth_comment_remove : {
            name: langs.popup_delete,
            icon: 'ion-android-remove-circle',
            api: '/ajax/booth/comment/remove',
            callback: function(apiData) {
                var a = confirm('Are you sure you want to delete this comment?');
                if (a) {
                    $.post(this.api, apiData, function(response) {
                        if (response.status === true) {
                            $('#booth-comment-id-' + apiData.commentId).hide('slow',function() {
                                $('#booth-comment-id-' + apiData.commentId).remove();
                            });
                        }
                    });
                }
                // closeActionPopup();
            }
        }

    };

    function justCallApi(api, apiData, callback) {
        $.post(api, apiData, function(response) {
            if (response.status === true) {
                
                // closeActionPopup();
                if (callback) {
                    callback();
                }
                
                require(['Toastr'], function(Toastr) {
                    new Toastr({
                        message: response.message
                    });
                });

            } else {
                if (response.status_code === Constants.status_code.no_auth_login) {
                    // Show login popup
                    require(['Auth'], function (Auth) {
                        Auth.showLoginPopup(true, {source: 'feed actions response'});
                    });
                    //alert('You need to login (login popup)');
                } else if (response.status_code === Constants.status_code.no_auth_group) {
                    alert('You need to join the group to like this answer');
                } else {
                    alert(response.message);
                }
            }

        });

        return false;
    }


    function initContentReportProcess (apiData, type) {
        var base = this;

        require(['modules/common/Report'], function(Report) {
            var options = {
                    containerId: 'reportContainer'
                },

                report = new Report();

            report.init(options, type, base, apiData);

            // closeActionPopup();
        });
    }

    // Close the Feed Action menu popup
    // function closeActionPopup (callback) {
    //     // Remove from DOM
    //     History.popState();
    //     // $(eleActionMenu).remove();
    //     if (callback) {
    //         callback();
    //     }
    // };



    // Enable editing Forms for Question and Answer
    function enableQAEdit ($elQAItem, $elQAText, QAText, $elQAEditForm, api, validationRules, callback) {
        $elQAText.addClass('hidden').after($elQAEditForm);
        var $input = $elQAEditForm.find('textarea');
        $input.val('').focus().val($.trim(QAText));

        // Auto-grow
        require(['autosize', 'Validation', 'Toastr', 'linkify', 'Helper'], function(autosize, Validation, Toastr, linkify, Helper) {
            // Enable Autogrow for textfield
            autosize($elQAEditForm.find('.autogrow'));

            $elQAEditForm.on('submit', function () {
                var form = this,
                    validation = new Validation({
                        form: this,
                        allConstraints: validationRules
                    });

                if (validation.isValid() === true) {
                    $elQAEditForm.addClass('loading');

                    $.post(api, $elQAEditForm.serialize(), function (response) {
                        $elQAEditForm.removeClass('loading');
                        if(response.status === true) {

                            if($elQAText.hasClass('booth-text')) {
                                $elQAText.html(Helper.parseTags(form.message.value));
                            } else {
                                $elQAText.html(Helper.nl2br($('<div/>').text(form.message.value).html()));
                                Helper.linkifyFeedContent($elQAText);    
                            }
                            

                            $elQAEditForm.off('submit');
                            new Toastr({
                                'message': response.message,
                                // 'icon': 'ion-alert',
                                'class': 'toastr-success'
                            });
                            closeQAEditForm($elQAEditForm, function () {
                                $elQAText.removeClass('hidden');
                            });
                            if(callback) {
                                callback(form.message.value);
                            }
                        } else {
                            console.log(response.message);
                        }
                    });
                }

                return false;
            });
        });


        // Close button
        $elQAEditForm.on('click', '.btn-close', function () {
            closeQAEditForm($elQAEditForm, function () {
                $elQAText.removeClass('hidden');
            });
        });

        // closeActionPopup();
    }

    // Close the QA Edit forms
    function closeQAEditForm ($form, callback) {
        $form.off().remove();

        if(callback) {
            callback();
        }
    }



    /*
     * @type = feed ele type (question, answer, user)
     * @ActionList = array/json of ActionList allowed
     */
    var FeedAction = function(type) {
        var _self = this,
            _eleType = null, // question, answer, user, poll, article, video
            _$actionBtn = null,
            _apiData = {};

        function init() {
            if(type == 'poll') {
                type = 'question';
            }
            _eleType = type;

            // _self.show(actions, url);
            bindEvents();
        }

        function bindEvents() {

            // UI.$b.on('click', eleActionMenu, function(e) {
            //     e.preventDefault();
            //     if (e.target === this) {
            //         closeActionPopup();
            //     }
            // });

            // On click show Action list popup
            UI.$b.off('click', eleActionMenu + ' li').on('click', eleActionMenu + ' li', function(e) {
                e.preventDefault();
                var $item = $(this),
                    action = $item.data('action'),
                    actionName = _eleType + '_' + action;

                if (ActionList[actionName] !== undefined) {
                    ActionList[actionName].callback(_apiData, {
                        $actionBtn: _$actionBtn
                    });
                }
                History.popState();
                //e.stopImmediatePropagation();
                return false;
            });
        }

        function getActionName(action) {

            if(_eleType == 'question' || _eleType == 'video' || _eleType == 'article' || _eleType == 'poll') {
                _eleType = 'post';
            }

            var actionName = _eleType + '_' + action;
            //console.log(action_name);

            return ActionList[actionName] !== undefined ? ActionList[actionName].name : null;
        }

        function getActionIcon(action) {
            var actionName = _eleType + '_' + action;
            //console.log(action_name);

            return ActionList[actionName] !== undefined ? ActionList[actionName].icon : null;
        }

        _self.callAction = function(actionName, apiData, callback) {
            if (ActionList[actionName] !== undefined) {
                ActionList[actionName].callback(apiData, {
                    $actionBtn: _$actionBtn,
                    callback: callback
                });
            }
        };

        _self.showActionMenu = function(actions, apiData, $actionBtn, url) {
            var type,
                tmplData = [],
                actionListHtml;

            _apiData = apiData;
            _$actionBtn = $actionBtn;

            // ActionList = array/obj of ActionList
            if (!actions) {
                actions = {};
            }

            $.each(actions, function(i, v) {
                var name = getActionName(i),
                    icon = getActionIcon(i);

                if (name && v === true) {
                    tmplData.push([i, name, icon]);
                }
            });

            actionListHtml = template('tplFeedActionPopup', {
                tmplData: tmplData,
                url: url,
                langs: langs
            });

            // Remove any existing
            // $(eleActionMenu).remove(); // to be maintained by history
            UI.$b.append(actionListHtml);
            History.pushState({
                popupId: 'popup-action-menu',
                url: window.location.href
            });

        };

        init();

        return _self;
    };

    return FeedAction;
});
